import { Link } from '@tanstack/react-router';
import { useDroppable } from '@dnd-kit/core';
import clsx from 'clsx';
import Icon from '../ui/Icon';
import type { Tag } from '../../types/api';
import type { DropTargetData } from '../../contexts/BookmarkDndContext';
import { formatCount } from '../../utils/numberUtils';
import { useContextMenu } from '../../hooks/useContextMenu';
import SidebarItemMenu from './SidebarItemMenu';

export interface TagItemProps {
  tag: Tag;
  isActive: boolean;
}

function TagItem({ tag, isActive }: TagItemProps) {
  const contextMenu = useContextMenu();

  const dropData: DropTargetData = {
    type: 'tag',
    tagName: tag.name,
  };

  const { setNodeRef, isOver } = useDroppable({
    id: `tag-drop-${tag.id}`,
    data: dropData,
  });

  return (
    <li className="relative" onContextMenu={contextMenu.handleContextMenu}>
      <Link
        ref={setNodeRef}
        to="/tags/$slug"
        params={{ slug: tag.slug }}
        className={clsx(
          'side-item flex-between',
          !isActive && 'transition-all duration-150',
          isOver && !isActive && 'drop-target-highlight',
        )}
        data-active={isActive ? 'true' : undefined}
        data-droptarget={!isActive ? 'true' : undefined}
      >
        <div className="flex items-center gap-2 truncate">
          <Icon name="tag" className="flex-shrink-0" />
          <span className="truncate leading-normal">{tag.name}</span>
        </div>
        {tag.count > 0 && (
          <span className="side-nav-count" title={String(tag.count)}>
            {formatCount(tag.count)}
          </span>
        )}
      </Link>

      {contextMenu.anchorPosition && (
        <span className="absolute" aria-hidden>
          <SidebarItemMenu
            tag={tag}
            isActive={isActive}
            anchorPosition={contextMenu.anchorPosition}
            onOpenChange={contextMenu.handleOpenChange}
          />
        </span>
      )}
    </li>
  );
}

export default TagItem;
